// eslint-disable-next-line no-unused-vars
import React, { Component, Suspense } from 'react';
// eslint-disable-next-line no-unused-vars
import Loading from './../component/Loading';
// eslint-disable-next-line no-unused-vars
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from './config';

class Router extends Component {
  render () {
    return (
      <Suspense fallback={<Loading/>}>
        <Switch>
          {
            routes.map((routeObj, index) => {
              return <Route path={routeObj.path} component={routeObj.component} key={index}/>;
            })
          }
          {/* 默认路由 */}
          <Redirect to="/home"/>
        </Switch>
      </Suspense>
    );
  }
}

export default Router;
